import { render, staticRenderFns } from "./TiendaEtiquetaSelectComponent.vue?vue&type=template&id=449907f3&"
import script from "./TiendaEtiquetaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./TiendaEtiquetaSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./TiendaEtiquetaSelectComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports